import { render, staticRenderFns } from "./df-k3.vue?vue&type=template&id=63a969e2"
import script from "./df-k3.vue?vue&type=script&lang=js"
export * from "./df-k3.vue?vue&type=script&lang=js"
import style0 from "./df-k3.vue?vue&type=style&index=0&id=63a969e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports